import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

/** Solid surface card used across storefront and staff. */
export function GlassCard({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("rounded-xl border border-[#1677ff]/20 bg-[#061126]/75 p-6 backdrop-blur-md", className)} {...props} />;
}

export function BentoCard({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("relative overflow-hidden rounded-xl border border-white/10 bg-[#0a0a0a] p-8", className)} {...props} />;
}
